import { useEffect, useState } from 'react';
import Link from 'next/link';
import { useQueryClient } from 'react-query';
import { useRouter } from 'next/router';

import Checkbox from '@/atoms/Checkbox';
import routes from '@/constants/routes/index';

import getConfig from 'next/config';

const BecomePartner = (): JSX.Element => {
  const { publicRuntimeConfig } = getConfig();
  const router = useRouter();

  const { id, value } = router.query;

  const [checked, setChecked] = useState(false);
  const queryClient = useQueryClient();

  const onChange = () => {
    setChecked((checked) => !checked);
  };

  useEffect(() => {
    queryClient.clear();
  }, [queryClient]);

  useEffect(() => {
    if (id && value) {
      router.push({ pathname: routes.home.root, query: { id, value } });
    }
  }, [id, router, value]);

  if (id && value) return <div />;

  return (
    <section className="px-5">
      <h1 className="mt-8 mb-4 text-4xl font-bold md:mt-0 md:text-6xl text-grey-900">
        Become a partner
      </h1>
      <p className="font-serif text-2xl font-normal md:text-3xl text-grey-500">
        In a few questions, you can sign up to join Keyzy&apos;s intermediary
        network
      </p>
      <h2 className="mt-10 mb-6 text-2xl font-bold md:mt-16">
        Before we get started
      </h2>
      <div className="p-6 bg-white rounded md:p-10 shadow-3xl">
        <div>
          <Checkbox checked={checked} onChange={onChange} id="consent">
            I have read and understood Keyzy&apos;s{' '}
            <a
              className="underline"
              href={publicRuntimeConfig.NEXT_CUSTOMER_APP + '/terms-of-use'}
              target="_blank"
              rel="noreferrer"
            >
              Terms of Use{' '}
            </a>
            and{' '}
            <a
              href={publicRuntimeConfig.NEXT_CUSTOMER_APP + '/privacy'}
              className="underline"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Notice
            </a>
          </Checkbox>
          <Link href={routes.brokerDetails}>
            <a
              className={`mt-8 h-14 px-6 py-5 text-lg font-bold rounded btn-primary ${
                !checked && 'btn-primary--disabled'
              }`}
            >
              Join Keyzy
            </a>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BecomePartner;
